<template>
  <div class="auto cell">
    <span class="product__option_title cell show-for-between-medium-small">{{ bundleOption.title }}</span>
    <select :name="'bundle_option[' + bundleOption.option_id + ']'" :required="bundleOption.required">
      <option value="undefined" disabled selected>{{ $t('Choose a selection...') }}</option>
      <option v-for="selection in bundleOption.selections" :disabled="!selection.salable" :value="selection.selection_id">{{ selection.name }}{{ parseFloat(selection.price) > 0 ? ' (+' + selection.price.priceFormat() + ')': '' }}</option>
    </select>
    <input type="hidden" :name="'bundle_option_qty[' + bundleOption.option_id + ']'" value="1">
  </div>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'vue-property-decorator';

  @Component(
    {
      name: 'catalog-product-type-bundle-select'
    }
  )

  export default class extends Vue {
    @Prop() bundleOption: object;
  }
</script>
